import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
    title, 
    description, 
    keywords = [], 
    ogImage,
    ogUrl,
    canonical
  }) => {
    const siteTitle = 'Accufit';
    const defaultDescription = '누구나 쉽게 적절한 계정과목을 추천 받는 AI 서비스';
    const defaultKeywords = ['Accufit', '자동분개', 'AI회계', 'Recamix'];
    const defaultOgImage = 'https://recamix.pages.dev/og-image.jpg';
    const defaultUrl = 'https://recamix.pages.dev';
  
    return (
      <Helmet>
        <title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
        <meta name="description" content={description || defaultDescription} />
        <meta name="keywords" content={[...defaultKeywords, ...keywords].join(', ')} />
        
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={siteTitle} />
        <meta property="og:title" content={title ? `${title} | ${siteTitle}` : siteTitle} />
        <meta property="og:description" content={description || defaultDescription} />
        <meta property="og:image" content={ogImage || defaultOgImage} />
        <meta property="og:url" content={ogUrl || defaultUrl} />
        
        <link rel="canonical" href={canonical || defaultUrl} />
      </Helmet>
    );
  };

export default SEO;
